import { BIS_VERSION_LEVELS, BIS_VERSION_LEVEL_LABELS, bisNextVersionLabel, type BisVersionLevel } from '@raro/domain';
import { Segmented } from '@raro/ui';
/** o que a tela precisa do BIS para numerar: o rótulo em vigor e a próxima pela regra */
type Versioned = { versionLabel: string | null; next: { level: BisVersionLevel; why: string; label: string } | null };

/**
 * O tamanho da versão a publicar: a regra dá o nível pelo que mudou (e diz o bloco que puxou), e quem publica pode subir,
 * nunca descer. Devolve o rótulo que vai sair, para o botão.
 */
export function publishLabel(d: Versioned, level: BisVersionLevel | null) {
  const rule = d.next?.level ?? 'patch';
  const chosen = level && BIS_VERSION_LEVELS.indexOf(level) > BIS_VERSION_LEVELS.indexOf(rule) ? level : rule;
  return { rule, chosen, label: bisNextVersionLabel(d.versionLabel, chosen) };
}

export function PublishLevel({ d, level, onChange }: { d: Versioned; level: BisVersionLevel | null; onChange: (l: BisVersionLevel) => void }) {
  const { rule, chosen } = publishLabel(d, level);
  if (!d.next) return null;
  if (!d.versionLabel) return <small>a primeira versão sai como v1.0.0.</small>;
  const options = BIS_VERSION_LEVELS.slice(BIS_VERSION_LEVELS.indexOf(rule)).map((l) => ({ value: l, label: `${BIS_VERSION_LEVEL_LABELS[l]} · v${bisNextVersionLabel(d.versionLabel, l)}` }));
  return (
    <>
      <small>pela regra, {BIS_VERSION_LEVEL_LABELS[rule]}: {d.next.why}.{options.length > 1 ? ' se for mais do que isso, suba:' : ''}</small>
      {options.length > 1 && <Segmented options={options} value={chosen} onChange={(v) => onChange(v as BisVersionLevel)} />}
    </>
  );
}
